import { render } from "./PeripheralChips.vue?vue&type=template&id=e5beb3ee&scoped=true&ts=true"
import script from "./PeripheralChips.vue?vue&type=script&lang=ts"
export * from "./PeripheralChips.vue?vue&type=script&lang=ts"

import "./PeripheralChips.vue?vue&type=style&index=0&id=e5beb3ee&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5beb3ee"]])

export default __exports__